export const convertColumnsToValueObjects = function* convertColumnsToValueObjects(
  columns,
  returnKey
) {
  if (!columns) {
    return [];
  }

  for (const column of columns) {
    if (returnKey) {
      yield column.getColDef().field;
    } else {
      yield getValueObject({
        id: column.getId(),
        field: column.getColDef().field,
        displayName: column.getColDef().headerName,
        aggFunc: column.getAggFunc()
      });
    }
  }
};

export const getValueObject = function getValueObject({
  id,
  field,
  displayName,
  aggFunc
}) {
  return {
    id,
    field,
    displayName,
    aggFunc,
  };
};